import { Col, Container, Nav, Row, Tab } from "@themesberg/react-bootstrap";

import CustomerWiseReport from "./CustomerWiseReport";
import DealerWiseReport from "./DealerWiseReport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import ServiceEngWiseReport from "./ServiceEngWiseReport";
import { faUser } from "@fortawesome/free-regular-svg-icons";

// import AllServiceEntry from "./AllServiceEntry";

export default () => {
  return (
    <article>
      <Container className="px-0">
        <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
          <Col className="d-block mb-4 mb-md-0">
            <h5 className="head mb-4">Master Reports View</h5>
          </Col>
        </Row>
        <div>
          <Tab.Container defaultActiveKey="customerReport">
            <Row>
              <Col lg={12}>
                <Nav fill variant="pills" className="flex-column flex-sm-row">
                  <Nav.Item>
                    <Nav.Link eventKey="customerReport" className="mb-sm-3 mb-md-0">
                      <FontAwesomeIcon icon={faUser} className="me-2" />{" "}
                      Customer Wise Report
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="dealerReport" className="mb-sm-3 mb-md-0">
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      Dealer Wise Report
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="backofficeReport" className="mb-sm-3 mb-md-0">
                      <FontAwesomeIcon icon={faUser} className="me-2" /> Back
                      Office Wise Report
                    </Nav.Link>
                  </Nav.Item>*/}
                  <Nav.Item>
                    <Nav.Link eventKey="serviceengineerReport" className="mb-sm-3 mb-md-0">
                      <FontAwesomeIcon icon={faUser} className="me-2" /> Service
                      Engineer Wise Report
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="customerReport" className="py-4">
                    <CustomerWiseReport />
                  </Tab.Pane>
                  <Tab.Pane eventKey="dealerReport" className="py-4">
                    <DealerWiseReport />
                  </Tab.Pane>
                  <Tab.Pane eventKey="backofficeReport" className="py-4">
                    {/* <ServiceEngWiseReport /> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="serviceengineerReport" className="py-4">
                    <ServiceEngWiseReport />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </Container>
    </article>
  );
};
